import { Component, h } from 'preact'
import { subscribe } from '../../utils/globals'
import algoliasearch from 'algoliasearch/lite'
import { Tag } from './PublicTagSelect'
import Icon from '../assets'

interface Props {
  index: algoliasearch.Index,
  isTagSelected: (tag: string) => boolean,
  selectPublicTag: (tag: Tag, remainFocusOnInput: boolean) => void
}
interface State {
  suggestedTags: string[]
}
interface HitWithTags {
  tags: string[] | null
}
interface Hash<T> {
  [key: string]: T;
}

export default class AutoSuggestTags extends Component<Props, State> {
  index: algoliasearch.Index

  constructor (props: Props) {
    super(props)
    this.index = props.index
    this.state = {
      suggestedTags: []
    }
    subscribe('title_changed', ({ title } : { title: string }) => this.autoSuggest(title))
  }

  autoSuggest (topicName: string) {
    if (topicName === '') {
      this.setState({ suggestedTags: [] })
      return
    }
    this.props.index.search({ query: topicName, attributesToRetrieve: ['title', 'tags'] }).then(({ hits }: { hits: HitWithTags[] }) => {
      let tagSet: Hash<number> = {}
      const results = hits.reduce((result, hit) => {
        hit.tags && hit.tags.forEach(tag => {
          result.hasOwnProperty(tag) ? result[tag]++ : result[tag] = 1
        })
        return result
      }, tagSet)
      this.setState({ suggestedTags: Object.keys(results).sort((a, b) => results[b] - results[a]).slice(0, 3) })
    })
  }

  render ({ isTagSelected, selectPublicTag }: Props, { suggestedTags }: State) {
    return suggestedTags.length > 0 && <div class='public-tag-suggestions-container'>
      {
        suggestedTags.map(tag => isTagSelected(tag) ? null : <div class='suggested-public-tag' onClick={
          () => selectPublicTag({ name: tag }, false)
        }>{tag}&nbsp;<Icon icon='add' size={16} /></div>)
      }
    </div>
  }
}
